const PLATFORM_LABELS: Record<string, string> = {
  web: '웹',
  app: '앱',
  common: '웹+앱',
};

export const getPlatformDisplayLabel = (platform: string): string => {
  return PLATFORM_LABELS[platform] ?? platform;
};

export const platformFormat = (platform: string) => {
  if (platform === 'app') {
    return '[앱] ';
  } else if (platform === 'web') {
    return '[웹] ';
  } else if (platform === 'common') {
    return '[웹+앱] ';
  }
  return '';
};
